import { Controller } from "@hotwired/stimulus"

// Instructions tab controller for _edit_instructions partial.
// Handles: system message toggle visibility.
export default class extends Controller {
  connect() {
    this.initSystemMessageToggle()
  }

  initSystemMessageToggle() {
    $(".system-message-toggle").on("click.editInstr", function () {
      const isOpen = $(this).data("open")
      if (!isOpen) { $(this).data("open", true); $(this).text("Hide") }
      else { $(this).data("open", false); $(this).text("Show") }
      $(".system-message-control-group").fadeToggle("slow", "linear").removeClass("hide")
    })
  }
}
